import { css } from 'lit';

export const styles = css`
  .layout {
    padding: 20px;
  }
  .cards {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 20px 0;
  }
`;

